<template>
    <div class="cbs-list-avatars flex items-center">
        <vx-tooltip class="flex items-center" v-for="(item, index) in localValue" :key="index" :text="item[textKey]" position="top">
            <vs-avatar v-bind="$attrs" :src="item[avatarKey]" />
        </vx-tooltip>
        <vx-tooltip class="flex items-center" :text="`+${additionCount}`" position="top" v-if="additionCount">
            <vs-avatar v-bind="$attrs" :text="`+${additionCount}`" />
        </vx-tooltip>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    name: "CbsListAvatars",
    props: {
        value: {
            type: Array,
            required: true,
            validator: propValue => propValue.length === 0 || propValue.every(valueObj => typeof valueObj === "object")
        },
        textKey: {
            type: String,
            default: "text"
        },
        avatarKey: {
            type: String,
            default: "src"
        },
        maxItem: {
            type: Number,
            default: 2,
            validator: propValue => propValue > 0
        }
    },
    computed: {
        additionCount() {
            return this.value.length > this.maxItem ? this.value.length - this.maxItem : null;
        },
        localValue() {
            return this.value.filter((item, index) => index <= this.maxItem - 1);
        }
    }
}
</script>

<style lang="scss" scoped>
.cbs-list-avatars {
    ::v-deep .vs-avatar--text {
        font-size: 1rem;
        font-weight: normal;
        color: var(--color-black) !important;
        transform: translate(-50%, -50%) !important;
    }
}
</style>